"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDefinition = void 0;
function extractDefinition(operation) {
    return operation.query.definitions[0];
}
exports.extractDefinition = extractDefinition;
//# sourceMappingURL=operation.js.map